$(document).ready(function () {
  function redirectAnyPage() {
        window.location.href = `/pages/${window.settings.cartpage_jump}`
    }
    $(document).on('click', '.custom-selectt ul li', function() {
        var clickedCountry = $(this).text();
        
        if (clickedCountry === 'Pakistan') {
          console.log(`/pages/${window.settings.cartpage_jump}`, '<<');
           window.location.href = `/pages/${window.settings.cartpage_jump}`
        }
    });
});

window.addons = () => {
  var $selector = $(".addonproduct:checked");
  if ($selector.length) {
    var items = [];
    console.log($selector.length, $selector);
    $selector.each(function () {
      var $el = $(this),
        id = $el.val(),
        qty = 1,
        title = $el.attr('data-title'),
        myObj = {
          id: id,
          quantity: qty,
          properties: {"Addon for": title}
        };
      items.push(myObj);
    });

    let formData = {
      items: items,
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        // window.location.href= '/cart';
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  } else {
    return false;
  }
};
var data_title = $(".menu-dropdown__content li.active").attr("data-maint"),
  data_url = $(".menu-dropdown__content li.active").attr("data-mainl");
// if (data_title == null || data_url == null) {
//   data_title = $(".main-menu li.active li").attr("data-maint");
//   data_url = $(".main-menu li.active li").attr("data-mainl");
// }
if (data_title != null && data_url != null) {
  $(".breadcrumb li:eq(1)")
    .after(`<li class="breadcrumb__item" itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ListItem">
                <a class="breadcrumb__link" href="${data_url}" title="${data_title}" itemprop="item">
                  <span itemprop="name">${data_title}</span>
                </a><meta itemprop="position" content="3"></li>`);
}

